<template>
  <div>
<br/>
  <v-card class="utils" v-if="loggedIn">
    <v-card-actions>
      <v-btn v-if="loggedIn" @click='newProject'>New Project</v-btn>
    </v-card-actions>
  </v-card>

<v-card>
  <v-card-title> Stakes in My Projects </v-card-title>
  <v-card-text>
  <DataTable profile="my_project_stakes" v-on:row-click="openProject" />
  </v-card-text>
</v-card>

<v-card>
  <v-card-title> My Projects </v-card-title>
  <v-card-text>
  <DataTable profile="my_projects" v-on:row-click="openProject">
    <template v-slot:item.content="{ item }">
      <span>{{item.content | summary}}</span>
    </template>
  </DataTable>
  </v-card-text>
</v-card>

<v-card>
  <v-card-title> My Stakes in Projects </v-card-title>
  <v-card-text>
  <DataTable profile="my_stakes" />
  </v-card-text>
</v-card>

  </div>
</template>

<script>
import router from '../plugins/router'
import DataTable from './DataTable.vue'

import { mapGetters } from 'vuex'

//var log = console.log;

export default {
    components : {
        DataTable
    },
    data : function() {
        return {
            projects : [],
        }
    },
    computed: {
        loggedIn() {
            return !!this.$store.getters.uuid 
        },
        ...mapGetters([
            'uuid',
            'email'
        ])
    },
    created : function() {
    },
    methods : {
        openProject : function(p) {
console.log('DEBUG','openProject',p)
            let prj = p.proj_id || p.uuid
            router.push({ name: 'Project', params: { uuid: prj }})
            return false;
        },
        newProject : function() {
            router.push({ name: 'Project', params: { uuid: 0 } })
        },
        viewProject : function() {
            router.push({ name: 'Project', params: { uuid: 0 } })
        }
    }
}
</script>

<style scoped>
.project-list {
    width: 100%;
}
td {
    margin-left:0px;
}
.item-list {
    margin-left: auto;
    margin-right:auto;
}
.item-list td.title {
    text-align: left;
}
.item-list td.amount {
    text-align: right;
}
</style>
